<template>
<div :style="'background:url(' + require('@/assets/bg-top-right.png') +') fixed '" style="margin-top:200px">

     <div v-if="!isLoading" class="text-center mb-12">
          <span :style="'font-weight: bold;font-size:18px; color:'+(settings[0] ? settings[0].color : '#2F839D')">{{ getName('P4S1HeadTitle') }}</span>
          <h1 class="textSizeT">{{ getName('P4S1Title') }}</h1>
          <div class="h-decor" :style="'background:' + (settings[0] ? settings[0].color : '#2F839D') "></div>
     </div>
     <div v-else> 
          <v-skeleton-loader  ref="skeleton" type="text"></v-skeleton-loader> 
          <v-skeleton-loader  ref="skeleton" type="text"></v-skeleton-loader> <br><br>
     </div>

     <section v-if="isShow(1)" :style="'background:url(' + require('@/assets/bg-top-right.png') +') fixed '">

          <v-row v-if="!isLoading">
               <v-col  v-for="(item,i) in itemsVisible " :key="i" cols="12" lg="4" md="4" sm="6">

                    <v-hover v-if="item.elementName == 'elements'" v-slot:default="{ hover }">
                         <v-card class="mx-auto hand" color="grey lighten-4" max-width="100%">

                              <v-img :src="'galeri/'+ item.img | URL" aspect-ratio="1.54" cover>
                                   <v-expand-transition>
                                        <div v-if="hover" class="d-flex pa-3 transition-fast-in-fast-out grey darken-2 v-card--reveal display-3 white--text">
                                             <p style="color:#fff;text-align:center; font-size: 18px;line-height: 1.8em;">{{ localLang == 'fr' ? item.nameFr : item.nameAr }}</p>
                                        </div>
                                   </v-expand-transition>
                              </v-img>
                         </v-card>
                    </v-hover>
                    <v-hover v-else-if="item.elementName == 'P4S1Img1'" v-slot:default="{ hover }">
                         <v-card class="mx-auto hand" color="grey lighten-4" max-width="100%">

                              <v-img :src="'galeri/'+ item.img | URL">
                                   <v-expand-transition>
                                        <div v-if="hover" class="d-flex pa-3 transition-fast-in-fast-out grey darken-2 v-card--reveal display-3 white--text">
                                             <p style="color:#fff;text-align:center; font-size: 18px;line-height: 1.8em;">{{ localLang == 'fr' ? item.nameFr : item.nameAr }}</p>
                                        </div>
                                   </v-expand-transition>
                              </v-img>
                         </v-card>
                    </v-hover>
               </v-col>
          </v-row>
          <v-row v-else>
               <v-col cols="4"><v-skeleton-loader ref="skeleton" type="image"></v-skeleton-loader></v-col>
               <v-col cols="4"><v-skeleton-loader ref="skeleton" type="image"></v-skeleton-loader></v-col>
               <v-col cols="4"><v-skeleton-loader ref="skeleton" type="image"></v-skeleton-loader></v-col>
               <v-col cols="4"><v-skeleton-loader ref="skeleton" type="image"></v-skeleton-loader></v-col>
               <v-col cols="4"><v-skeleton-loader ref="skeleton" type="image"></v-skeleton-loader></v-col>
               <v-col cols="4"><v-skeleton-loader ref="skeleton" type="image"></v-skeleton-loader></v-col>
          </v-row>
     </section>
     <v-pagination class="mt-12" v-model="currentPage" @click="VisibleItem" :length="pageSize" circle></v-pagination>
</div>
</template>

<script>
export default {
     data: () => ({
          currentPage: 1,
          chunk: 9,
          itemsVisible: [],
          items: []
     }),
     methods: {

          paginate(arr, size) {
               return arr.reduce((acc, val, i) => {
                    let idx = Math.floor(i / size)
                    let page = acc[idx] || (acc[idx] = [])
                    page.push(val)
                    return acc
               }, [])
          },
          /********************************** */ 
          isShow(item) {
               let array = this.$store.state.status.filter(e => e.idPage == 4)
               if (array) {
                    for (let i = 0; i < array.length; i++) {
                         if (array[i].idSection == item) {
                              return false
                         } else {
                              return true
                         }
                    }
               }
               return true
          },
          /********************************** */
          uniqueArray(array) {
               return array.filter((thing, index) => {
                    const _thing = JSON.stringify(thing);
                    return index === array.findIndex(obj => {
                         return JSON.stringify(obj) === _thing;
                    });
               });
          }
     },
     computed: {
          itemsGaleri() {
               return this.itemsVisible.filter(e => e.elementName == 'elements')
          },
          pushItemGaleri() {
               let ii = 1
               this.galeriItem.filter((e, i) => {
                    if (e.nameFr == '/') {
                         this.items.push({
                              img: 'elements' + ii,

                         })
                         ii++
                    }
               })
               return this.items
          },
          VisibleItem(page) {
               page = this.currentPage - 1
               this.itemsVisible = this.paginate(this.uniqueArray(this.galeriItem), this.chunk)[page]
          },
          pageSize() {
               return Math.ceil(this.uniqueArray(this.galeriItem).length / this.chunk) 
          },
           
          galeriItem() {
               return this.$store.state.galeriItem
          }

     },
}
</script>

<style scoped>
.testHover:hover {
     background: testHover;
}

.v-card--reveal {
     align-items: center;
     bottom: 0;
     justify-content: center;
     opacity: .6;
     position: absolute;
     width: 100%;
     height: 100%
}
</style>
